export default "__VITE_ASSET__BcwXh2Qp__"